import { TSpendingLimitType } from '../../hooks/useGetSpendingLimits';

const SELLER_PRODUCT_TO_DURATION_IN_MONTHS = {
    THIRTY_DAYS: 1,
    THREE_MONTHS: 3,
    TWELVE_MONTHS: 12
} as const satisfies Record<TSpendingLimitType, number>;

export const mapSellerProductToDurationInMonths = ({
    sellerProduct
}: {
    sellerProduct?: keyof typeof SELLER_PRODUCT_TO_DURATION_IN_MONTHS;
}) => {
    if (!sellerProduct) return null;
    return SELLER_PRODUCT_TO_DURATION_IN_MONTHS[sellerProduct];
};
